﻿/**
 * ============================================================
 * Bahasa_Indonesia
 * ============================================================
 *
 * Translators:
 *
 * mnafisalmukhdi1 <contact.mnam@gmail.com>
 */



export default {
	'AdvanceHelp': 'Untuk melanjutkan permainan, klik kiri atau ketuk di mana saja pada layar permainan atau tekan tombol spasi',
	'AllowPlayback': 'Klik di sini untuk menyalakan putar balik audio',
	'Audio': 'Audio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Nyalakan main otomatis',
	'AutoPlaySpeed': 'Kecepatan main otomatis',

	'Back': 'Kembali',
	'BackButton': 'Kembali',

	'Cancel': 'Batalkan',
	'Close': 'Tutup',
	'Confirm': 'Apakah Anda ingin keluar?',
	'Credits': 'Kredit',

	'Delete': 'Hapus',
	'DialogLogButton': 'Tampilkan log dialog',

	'FullScreen': 'Layar Penuh',

	'Gallery': 'Galeri',

	'Help': 'Bantuan',
	'Hide': 'Sembunyikan',
	'HideButton': 'Sembunyikan kotak teks',

	'iOSAudioWarning': 'Pengaturan audio tidak didukung pada iOS',

	'KeyboardShortcuts': 'Pintasan papan tombol',

	'Language': 'Bahasa',
	'Load': 'Muat',
	'LoadAutoSaveSlots': 'Permainan yang Tersimpan Otomatis',
	'LoadButton': 'Buka layar pemuatan',
	'Loading': 'Memuat',
	'LoadingMessage': 'Tunggu sementara aset dimuat',
	'LoadSlots': 'Permainan yang Tersimpan',
	'LocalStorageWarning': 'Penyimpanan lokal tidak tersedia pada peramban ini',
	'Log': 'Log',

	'Music': 'Volume Musik',

	'NewContent': 'Ada konten baru tersedia, muat ulang halaman untuk mendapatkan versi terkini',
	'NoSavedGames': 'Tidak ada permainan yang tersimpan',
	'NoAutoSavedGames': 'Tidak ada permainan yang tersimpan otomatis',
	'NoDialogsAvailable': 'Tidak ada dialog yang tersedia. Dialog akan ditampilkan di sini ketika muncul',

	'OK': 'OK',
	'OrientationWarning': 'Mohon putar perangkat Anda untuk bermain',
	'Overwrite': 'Timpa',

	'QuickButtons': 'Tombol Menu Pintas',
	'QuickMenu': 'Menu Pintas',
	'Quit': 'Keluar',
	'QuitButton': 'Keluar Permainan',

	'Resolution': 'Resolusi',

	'Save': 'Simpan',
	'SaveButton': 'Buka layar Simpan',
	'SaveInSlot': 'Simpan di slot',
	'SelectYourLanguage': 'Pilih bahasa Anda',
	'Settings': 'Pengaturan',
	'SettingsButton': 'Buka layar Pengaturan',
	'Show': 'Tampilkan',
	'Skip': 'Lewati',
	'SkipButton': 'Masuki mode lewati',
	'SlotDeletion': 'Apakah Anda yakin ingin menghapus slot ini?',
	'SlotOverwrite': 'Apakah Anda yakin ingin menimpa slot ini?',
	'Sound': 'Volume Bunyi',
	'Start': 'Mulai',
	'Stop': 'Berhenti',

	'TextSpeed': 'Kecepatan Teks',

	'Video': 'Volume Video',
	'Voice': 'Volume Suara',

	'Windowed': 'Berjendela'
};